import { CATEGORIES } from './blogTypes'
import type { Category, CategorySlug, Post } from './blogTypes'
import { costOfDormerWindow } from './posts/costOfDormerWindow'
import { planningPermission } from './posts/planningPermission'
import { shedVsGable } from './posts/shedVsGable'
import { roofArea } from './posts/roofArea'
import { regulationsInsulation } from './posts/regulationsInsulation'

export { CATEGORIES }
export type { Category, CategorySlug, Post }

export const POSTS: Post[] = [
  costOfDormerWindow,
  planningPermission,
  shedVsGable,
  roofArea,
  regulationsInsulation,
]

export function getPost(slug: string): Post | undefined {
  return POSTS.find(p => p.slug === slug)
}

export function getCategory(slug: string): Category | undefined {
  return CATEGORIES.find(c => c.slug === slug)
}

export function getPostsByCategory(slug: CategorySlug): Post[] {
  return POSTS.filter(p => p.category === slug)
}

export function formatDate(iso: string): string {
  return new Date(iso + 'T00:00:00Z').toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  })
}
